// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.refresh_icon {
  cursor: pointer;
  color: #71B03C;
}

p, h1, h2, h3, h4, h6, h5 {
  font-family: "Overpass", sans-serif;
}

.btninprog {
  background-color: transparent;
  color: #71B03C;
}

.status-pending {
  color: green;
}

.status-completed {
  color: #0b4599;
}

.status-processing {
  color: #ff00a6;
}

.status-24hrs {
  color: #ff5100;
}

.status-after24hrs {
  color: #ff004c;
}`, "",{"version":3,"sources":["webpack://./src/app/views/pages/bvg/bvg.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF;;AACA;EACE,mCAAA;AAEF;;AAAA;EACE,6BAAA;EACA,cAAA;AAGF;;AADA;EACE,YAAA;AAIF;;AAFA;EACE,cAAA;AAKF;;AAHA;EACE,cAAA;AAMF;;AAJA;EACE,cAAA;AAOF;;AALA;EACE,cAAA;AAQF","sourcesContent":[".refresh_icon {\n  cursor: pointer;\n  color: #71B03C;\n}\np, h1, h2, h3, h4, h6, h5 {\n  font-family: \"Overpass\", sans-serif;\n}\n.btninprog {\n  background-color: transparent ;\n  color: #71B03C;\n}\n.status-pending {\n  color: green;\n}\n.status-completed {\n  color: #0b4599;\n}\n.status-processing {\n  color: #ff00a6;\n}\n.status-24hrs {\n  color: #ff5100;\n}\n.status-after24hrs{\n  color: #ff004c;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
